export const QUANTITY_TYPE_VALUE = 1;
export const AMOUNT_TYPE_VALUE = 2;
export const QUANTITY_TYPE_LABEL = '数量指定';
export const AMOUNT_TYPE_LABEL = '金額指定';

export const ORDER_FREQUENCY_DAILY_VALUE = '1';
export const ORDER_FREQUENCY_DAILY_LABEL = '毎日';
export const ORDER_FREQUENCY_WEEKLY_VALUE = '2';
export const ORDER_FREQUENCY_WEEKLY_LABEL = '毎週';
export const ORDER_FREQUENCY_MONTHLY_VALUE = '3';
export const ORDER_FREQUENCY_MONTHLY_LABEL = '毎月';
export const DEFAULT_ORDER_FREQUENCY_VALUE = ORDER_FREQUENCY_DAILY_VALUE;

export const FIELD_NAME_STATUS = 'status';
export const FIELD_NAME_INSTRUMENT_ID = 'instrumentId';
export const FIELD_NAME_SIDE = 'side';
export const FIELD_NAME_QUANTITY = 'quantity';
export const FIELD_NAME_AMOUNT = 'amount';
export const FIELD_NAME_ORDER_FREQUENCY = 'orderFrequency';
export const FIELD_NAME_RATE_LIMIT = 'rateLimit';
export const FIELD_NAME_QUANTITY_LIMIT = 'quantityLimit';

export const QuantityAmountTypeOptions = Object.freeze([
  { value: QUANTITY_TYPE_VALUE, name: QUANTITY_TYPE_LABEL },
  { value: AMOUNT_TYPE_VALUE, name: AMOUNT_TYPE_LABEL },
]);
export const OrderFrequencyOptions = Object.freeze([
  { value: ORDER_FREQUENCY_DAILY_VALUE, name: ORDER_FREQUENCY_DAILY_LABEL },
  { value: ORDER_FREQUENCY_WEEKLY_VALUE, name: ORDER_FREQUENCY_WEEKLY_LABEL },
  { value: ORDER_FREQUENCY_MONTHLY_VALUE, name: ORDER_FREQUENCY_MONTHLY_LABEL },
]);
